export default __webpack_public_path__ + "static/media/1A.662338fb.jpg";